import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { translationChunksConfig, translations } from '@spartacus/assets';
import { OccConfig, provideConfig } from '@spartacus/core';
import {
  defaultCmsContentProviders,
  layoutConfig,
  mediaConfig,
} from '@spartacus/storefront';
import { environment } from 'src/environments/environment';

const occConfig: OccConfig = { backend: { occ: {} } };
// onlyy provide the `occ.baseUrl` key if it is explicitly configured, otherwise the value of
// <meta name="occ-backend-base-url" > is ignored.
// This in turn breaks the deployment in CCv2.
// https://github.com/SAP/spartacus/issues/5886
occConfig.backend.occ.prefix = '/sanofiusocc/v2/';
occConfig.backend.occ.useWithCredentials = true;
if (environment.occBaseUrl) {
  occConfig.backend.occ.baseUrl = environment.occBaseUrl;
}

const PRODUCT_TYPE = 'DEFAULT';
let baseSiteId = window.location.pathname.substring(1, 4);
const cartId =
  baseSiteId == 'vax'
    ? JSON.parse(localStorage.getItem('spartacus⚿vax⚿cart'))?.active
    : JSON.parse(localStorage.getItem('spartacus⚿vsh⚿cart'))?.active;
@NgModule({
  declarations: [],
  imports: [BrowserModule],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig({
      backend: occConfig.backend,
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',
        // TODO: adjust origins as necessary
        allowOrigin:
          '*.aventis.com:8088,*.aventis.com:443,us-d3-admin.pharma.aventis.com:80,us-d3-admin.pharma.aventis.com:8080,us-d3-admin.pharma.aventis.com:8088,us-d3-admin.pharma.aventis.com:443,us-d3-admin.pharma.aventis.com:8443,us-s2-admin.pharma.aventis.com:80,us-s2-admin.pharma.aventis.com:8080,us-s2-admin.pharma.aventis.com:8088,us-s2-admin.pharma.aventis.com:443,us-s2-admin.pharma.aventis.com:8443,us-s1-admin.pharma.aventis.com:80,us-s1-admin.pharma.aventis.com:8080,us-s1-admin.pharma.aventis.com:8088,us-s1-admin.pharma.aventis.com:443,us-s1-admin.pharma.aventis.com:8443,*.ondemand.com:80,*.ondemand.com:8080,*.ondemand.com:8088,*.ondemand.com:443,*.ondemand.com:8443,*.ondemand.com:9002,localhost:9022, api.us-s1.sanofiecomm.com:8080, api.us-s1.sanofiecomm.com:8443,api.us-s1.sanofiecomm.com:8088,*.sanofiecomm.com:8080,*.sanofiecomm.com:8443,*.sanofiecomm.com:8088,*.sanofiecomm.com:9002,*.sanofiecomm.com:443',
      },
      context: {
        urlParameters: ['baseSite', 'language', 'currency'],
        baseSite: ['vsh', 'vax'],
        //baseSite: ['vsca'],
        currency: ['USD'],
        //currency: ['CAD'],
        language: ['en'],
      },
      i18n: {
        resources: translations,
        chunks: translationChunksConfig,
        fallbackLang: 'en',
      },
      features: {
        level: '6.6',
      },
    }),
    provideConfig({
      backend: {
        occ: {
          endpoints: {
            asmCustomerSearch: `/sanofiusocc/v2/${baseSiteId}/assisted-service/customers/search`,
            // product: {
            //   default:
            //     'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(DEFAULT),baseOptions,baseProduct,variantOptions,variantType',
            //   details:
            //     'products/${productCode}?fields=averageRating,stock(DEFAULT),description,availableForPickup,code,url,price(DEFAULT),numberOfReviews,manufacturer,categories(BASIC,name,url),priceRange,multidimensional,tags,images(FULL)',
            // },

            product:
              'products/${productCode}?fields=name,baseProduct,variantOptions(description,DEFAULT),variantType,code,description,manufacturer,baseProductName,baseProductDescription,images(DEFAULT),documents(DEFAULT),resources(DEFAULT),variants(code,description,url,DEFAULT),url,purchasable,categories(name,url,DEFAULT),storageDescription,calculator,formularyProduct,flu,shipNow,fluCategories,available,unavailable,orderable,discontinued,uom,quantityPerUnit,productUnavailableForEmployee,ndcCode,innerText,callNote,yellowFever,discontinuedText',
            productSearch: `products/search?fields=products(${PRODUCT_TYPE},images(DEFAULT)),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery`,
            productReferences:
              'products/${productCode}/references?referenceType=CROSSELLING&locationId=',
            cart: `user/current/carts/${cartId}?fields=DEFAULT,potentialProductPromotions,appliedProductPromotions,potentialOrderPromotions,appliedOrderPromotions,entries(totalPrice(formattedValue),product(images(FULL),stock(FULL)),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),totalUnitCount,deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue,%20value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),user,saveTime,name,description&lang=en&curr=USD`,
            // product:'products/${productCode}?fields=code,name,summary,price(formattedValue,DEFAULT),images(galleryIndex,FULL),baseProduct,averageRating,stock(DEFAULT),description,availableForPickup,url,numberOfReviews,manufacturer,categories(BASIC),priceRange,multidimensional,tags,DEFAULT,classifications,baseOptions,variantOptions,variantType',
            // product: {
            //   default:
            //     'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(DEFAULT),baseOptions,baseProduct,variantOptions,variantType',
            //   details:
            //     'products/${productCode}?fields=averageRating,stock(DEFAULT),description,availableForPickup,code,url,price(DEFAULT),numberOfReviews,manufacturer,categories(BASIC),priceRange,multidimensional,tags,images(FULL)',
            // },

            //https://api.us-s1.sanofiecomm.com/sanofiusocc/v2/vax/users/current/carts/5041479?fields=DEFAULT,potentialProductPromotions,appliedProductPromotions,potentialOrderPromotions,appliedOrderPromotions,entries(totalPrice(formattedValue),product(images(FULL),stock(FULL)),basePrice(formattedValue,value),updateable),totalPrice(formattedValue),totalItems,totalPriceWithTax(formattedValue),totalDiscounts(value,formattedValue),subTotal(formattedValue),totalUnitCount,deliveryItemsQuantity,deliveryCost(formattedValue),totalTax(formattedValue,%20value),pickupItemsQuantity,net,appliedVouchers,productDiscounts(formattedValue),user,saveTime,name,description&lang=en&curr=USD
          },
        },
      },
    } as OccConfig),
  ],
})
/*
 *  https://api.czz3177o4e-sanofiave3-d1-public.model-t.cc.commerce.ondemand.com/occ/v2/vsca
 * /products/search?fields=products(DEFAULT)%2C
 * facets%2Cbreadcrumbs%2C
 * pagination(DEFAULT)%2Csorts(DEFAULT)%2C
 * freeTextSearch%2C
 * currentQuery&query=%3Arelevance%3AallCategories%3A1&pageSize=10&lang=en&curr=CAD
 * */
export class SpartacusConfigurationModule {}
